import { render, staticRenderFns } from "./_AchatCredits.vue?vue&type=template&id=4e03a921&scoped=true&"
import script from "./_AchatCredits.vue?vue&type=script&lang=js&"
export * from "./_AchatCredits.vue?vue&type=script&lang=js&"
import style0 from "./_AchatCredits.vue?vue&type=style&index=0&id=4e03a921&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e03a921",
  null
  
)

export default component.exports